import BancMesureSection, { DENSITE_BANC_CONFIG } from "./BancMesureSection";

export default function DensiteBancSection(props) {
  return <BancMesureSection config={DENSITE_BANC_CONFIG} {...props} />;
}
